import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// Slice name
const name = "register";

// Create slice
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// Exports
export const registerActions = { ...slice.actions, ...extraActions };
export const registerReducer = slice.reducer;

// Implementation

function createInitialState() {
  return {
    registerData: [],
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {
    clearRegisterResponse,
  };

  function clearRegisterResponse(state) {
    state.registerData = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/LoginUser/InsertUpdatePublicUser`;

  return {
    registerUser: createAsyncThunk(
      `${name}/registerUser`,
      async ({ formData, isInvitedURL }, thunkAPI) => {
        try {
          const dataToSend = {
            ...formData,
            isInvitedURL, // Include isInvitedURL in the data being sent
          };
          const response = await fetchWrapper.post(baseUrl, dataToSend);
          return response;
        } catch (error) {
          return thunkAPI.rejectWithValue(
            error.message || "Something went wrong"
          );
        }
      }
    ),
  };
}

function createExtraReducers(builder) {
  const { registerUser } = extraActions;

  builder
    .addCase(registerUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(registerUser.fulfilled, (state, action) => {
      state.loading = false;
      state.registerData = action.payload;
      state.error = null;
    })
    .addCase(registerUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
}
